import React from 'react';
import { roles } from '../../static';
import { UserFormFields } from '../shared/Forms/GeneralUserFormFields';

function ClientForm() {
  return (
    <UserFormFields
      userType={roles.client}
      header={{
        title: 'Ver cliente',
      }}
    />
  );
}

export default ClientForm;
